import { Button } from "@Light/components/page/Button";
import { MutationButton } from "@Light/components/page/MutationButton";
import { useScaffold } from "@Light/scaffold";
import { useLight } from "@Light/services/light";
import { PayInvoiceRequest } from "@Light/services/lightTypes";
import { useMutation } from "@Light/utils/mutation";
import clsx from "clsx";
import { CardDescription, useInvoiceLink } from "./common";
import { useInvoice } from "./context";

export type PayInvoiceButtonProps = {};

export const PayInvoiceButton: React.FC<PayInvoiceButtonProps> = ({}) => {
  const { invoice } = useInvoice();
  const scaffold = useScaffold();
  const { useGetPaymentMethodQuery, usePayInvoiceMutation } = useLight();
  const paymentMethod = useGetPaymentMethodQuery();
  const payInvoice = useMutation<PayInvoiceRequest>(usePayInvoiceMutation);
  const invoiceLink = useInvoiceLink(invoice);

  const mutate = () => {
    payInvoice.mutate({
      invoiceNumber: invoice.number,
      allow_payment_before_due_date: true,
    });
  };

  if (paymentMethod.isLoading) {
    return null;
  }

  const Navigate = scaffold.system.navigate;
  if (payInvoice.isSuccess) {
    return <Navigate to={`${invoiceLink}payment-confirmed`} />;
  }

  if (paymentMethod.isError) {
    return (
      <div className="flex flex-col gap-2">
        <div className={clsx("text-sm", scaffold.page.colors.text.secondary)}>
          You have no payment method configured.
        </div>
        <Button disabled>Pay</Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <div className={clsx("text-sm", scaffold.page.colors.text.secondary)}>
        By clicking "Pay", your <CardDescription /> will be charged $
        {invoice.total}.
      </div>
      <MutationButton
        size="lg"
        mutate={mutate}
        mutation={payInvoice}
        mutateButtonText="Pay"
        errorMessage="Payment failed"
      />
    </div>
  );
};
